export default __webpack_public_path__ + "images/6410a1b7f657e78a3b82040b8c3356f8.svg";